import { render, staticRenderFns } from "./attestation.vue?vue&type=template&id=2e3ced8b&scoped=true"
import script from "./attestation.vue?vue&type=script&lang=js"
export * from "./attestation.vue?vue&type=script&lang=js"
import style0 from "./attestation.vue?vue&type=style&index=0&id=2e3ced8b&prod&lang=scss&scoped=true"
import style1 from "./attestation.vue?vue&type=style&index=1&id=2e3ced8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3ced8b",
  null
  
)

export default component.exports